import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { listenForOutsideClicks } from '../../utils';

// COMPONENTS
import CircleImage from '../../components/CircleImage';
import Button from '../../components/Button';

// ICONS
import { ReactComponent as SeachIcon } from '../../assets/svg/search.svg';

// TYPES
export interface SearchAdditionalStaffTypes {
	placeholder?: string;
	onChange?: any;
	isFullWidth?: boolean;
	complaintId?: string;
	setShowAddStaffControl: React.Dispatch<React.SetStateAction<boolean>>;
	displayClickResult: ComplaintStaffCandidatesStaffProfile;
	setDisplayClickResult: React.Dispatch<React.SetStateAction<ComplaintStaffCandidatesStaffProfile>>;
}

import { ComplaintStaffCandidatesStaffProfile } from '../../api/models';

const SearchAdditionalStaff: React.FC<SearchAdditionalStaffTypes> = ({
	placeholder = 'Search...',
	onChange,
	isFullWidth,
	complaintId,
	setShowAddStaffControl,
	displayClickResult,
	setDisplayClickResult
}) => {
	const [query, setQuery] = React.useState<string | undefined>('');

	const [searchResults, setSearchResults] = React.useState<ComplaintStaffCandidatesStaffProfile[]>([]);

	const [hasError, setHasError] = React.useState<boolean>(false);

	const [isActive, setIsActive] = React.useState<boolean>(false);

	const initialDisplayResult: ComplaintStaffCandidatesStaffProfile = {
		id: undefined,
		userId: undefined,
		name: undefined,
		role: undefined,
		profileImage: undefined
	};

	const searchData = async (complaintId: string, name: string) => {
		const response = await apibridge.searchComplaintResolveStaffMember(complaintId, name);

		if (!response.isError && response.result) {
			setHasError(false);

			const { result = [] } = response;

			setSearchResults(result);
		} else {
			setHasError(true);

			setSearchResults([]);
		}
	};

	const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const val = e.target.value;

		setQuery(val);

		if (onChange) {
			onChange(undefined);
		}

		if (!val) {
			setIsActive(false);
		} else {
			setIsActive(true);

			searchData(complaintId || '', val);
		}
	};

	const onClickPostHandler = (item: ComplaintStaffCandidatesStaffProfile) => {
		setIsActive(false);

		setDisplayClickResult(item);

		setQuery('');

		if (onChange) {
			onChange(item);
		}
	};

	const removeStaffDisplay = () => {
		setDisplayClickResult(initialDisplayResult);

		setShowAddStaffControl(false);
	};

	//  Logic to detect outside click and close search container
	const searchContainerRef = React.useRef(null);
	listenForOutsideClicks(searchContainerRef, isActive, setIsActive);

	return (
		<div className={`search-wrapper`}>
			{displayClickResult && displayClickResult.id ? (
				<div className="search-input-container display w-100">
					<div className="display-info">
						<div className="display-info-left">
							<CircleImage src={displayClickResult.profileImage} size={32} />
							<p className="display-name">{displayClickResult.name}</p>
						</div>

						<div className="display-info-right">
							<Button className="btn-text" onClick={removeStaffDisplay}>
								Remove
							</Button>
						</div>
					</div>
				</div>
			) : (
				<div className={`search-input-container ${isActive ? 'active' : ''} ${isFullWidth ? 'w-100' : ''}`}>
					<SeachIcon className="search-icon" />

					<input
						className="search-input"
						type="text"
						placeholder={placeholder}
						value={query}
						onChange={onChangeHandler}
						onClick={() => setIsActive(!!query)}
					/>
				</div>
			)}

			{(hasError || searchResults) && (
				<div
					ref={searchContainerRef}
					className={`search-result-container ${isActive ? 'active' : ''} ${isFullWidth ? 'w-100' : ''}`}
				>
					<ul>
						{hasError ? (
							<li className="search-result-item">No results found</li>
						) : (
							searchResults.map((item) => {
								return (
									<li onClick={() => onClickPostHandler(item)} key={item.id} className="search-result-item">
										<CircleImage fullName={item.name} src={item.profileImage} isColorBorder={true} size={32} />

										<div className="item-left">
											<span className="name">{item.name}</span>
										</div>

										<div className="item-right">{item.role}</div>
									</li>
								);
							})
						)}
					</ul>
				</div>
			)}
		</div>
	);
};

export default SearchAdditionalStaff;
